import * as React from "react";
import { Layout } from "antd";

import DefectValidator from "../../components/DefectValidator";
import { EventFilter } from "../../api/Types";
import { StoreAnalytics } from "../../store/storeAnalytics";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import Paths from "../../constants/PathsBreadcrumbs";

const store = new StoreAnalytics();

const SitReestr: React.FC = () => {
  useBreadcrumbs(Paths.spReestr);

  const initialFilter: EventFilter = {
    buildings: null,
    dateFrom: null,
    dateTo: null,
    deadlinesViolated: null,
    diameter: null,
    disconnections: null,
    eliminated: null,
    eventLevel: "Current",
    gridTypeIds: [],
  };

  return (
    <Layout
      className="container site-layout"
      style={{ flexDirection: "column" }}
    >
      <DefectValidator />
    </Layout>
  )
};

export default SitReestr;
